import { defineCustomElement } from '../chunks/vidstack-BGSTndAW.js';
import { MediaPlayerElement, MediaProviderElement } from '../chunks/vidstack-CejDJ6BP.js';
import '../chunks/vidstack-BUfZMlAO.js';
import '../chunks/vidstack-DJDnh4xT.js';
import '../chunks/vidstack-xMS8dnYq.js';
import '../chunks/vidstack-ChQTHmIQ.js';
import '../chunks/vidstack-Ci54COQW.js';
import '../chunks/vidstack-CTojmhKq.js';
import '../chunks/vidstack-DYbwIVLq.js';
import '../chunks/vidstack-D5EzK014.js';
import '../chunks/vidstack-B01xzxC4.js';
import '../chunks/vidstack-C9vIqaYT.js';
import '../chunks/vidstack-C2US-gSO.js';
import '@floating-ui/dom';
import '../chunks/vidstack-Dihypf8P.js';
import '../chunks/vidstack-DsPOyKtl.js';

defineCustomElement(MediaPlayerElement);
defineCustomElement(MediaProviderElement);
